/**
 * Given the raw description transform it into a dictionary with text to replace on copy events
 *
 * Example of onCopy tags: [onCopy]"-2":"-3", "hello":"bye"[/onCopy]
 *
 * @param {*} description The description text
 * @returns Dictionary with texts to replace on copy events
 */
export default function getDescriptionOnCopyDictionary(description) {
  let computedDescription = description || '';
  if (!computedDescription) return;
  const onCopyTexts = getOnCopyTexts(computedDescription);

  let dictionary = [];
  for (const onCopyText of onCopyTexts) {
    dictionary = dictionary.concat(getOnCopyDictionaryFromText(onCopyText));
  }
  return dictionary;
}

// From description get contents of all onCopy tags
const getOnCopyTexts = (description) => {
  const startTag = `[onCopy]`;
  const endTag = `[/onCopy]`;
  let onCopyTexts = [];
  let endTagIndex = 0;
  while (true) {
    let startTagIndex = description.indexOf(startTag, endTagIndex);
    endTagIndex = description.indexOf(endTag, startTagIndex + startTag.length);
    if (startTagIndex < 0 || endTagIndex < 0) break;
    onCopyTexts.push(description.substring(startTagIndex + startTag.length, endTagIndex));
  }
  return onCopyTexts;
};

// Make onCopy text into a list with from to values
const getOnCopyDictionaryFromText = (onCopyText) => {
  let dictionary = [];

  // key must be at least 1 character, but value can be empty
  let dictRegex = /"([^"]+)"\s*:\s*"([^"]*)"/gm;
  let regexResult = onCopyText.matchAll(dictRegex);
  let regexMatch = regexResult.next();
  while (!regexMatch.done) {
    if (regexMatch.value?.length > 2) {
      dictionary.push({ from: regexMatch.value[1], to: regexMatch.value[2] });
    }
    regexMatch = regexResult.next();
  }

  return dictionary;
};
